// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notes[data-v-77f72127] {\n  display: flex;\n}\n.notes .briq-panel[data-v-77f72127] {\n  width: 600px;\n  margin-right: 32px;\n}\n.header[data-v-77f72127] {\n  display: flex;\n  justify-content: space-between;\n}\np[data-v-77f72127] {\n  background-color: #f1f3f6;\n  border: solid 1px #ececec;\n  padding: 8px 12px 10px 11px;\n}\n.modal-actions[data-v-77f72127] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
